import { useEffect } from "react";
import { withRouter } from "../../hooks/withRouter";
const PageScrollTop = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return props.children;
};
export default withRouter(PageScrollTop);
